<template>
<div id="TimeContent">
    <h4 v-show="this.EmployeeAv.length == 0 && this.RoomAv.length == 0 || showError" v-html="this.ErrorMessage"></h4>
    <div :key="index" v-for="index in this.tabCount">
      <b-btn v-bind:style="{ 'border-color': HexColor }" v-b-toggle="'collapse' + index" class="list-group-item btn-outline-light activity-button">{{ splittedTimes[index-1][0].StartTime }} 
          - {{ splittedTimes[index-1][splittedTimes[index-1].length-1].EndTime }}</b-btn>
      <b-collapse :id="'collapse' + index">
        <b-card style="margin-left: 3%; margin-right: 3%;" v-bind:style="{ 'border-color': HexColor }">
          <button class="btn btn-outline-dark time-button" 
            v-bind:key="time.StartTime + '-' + time.EndTime" v-for="time in splittedTimes[index-1]"
            v-bind:id="time.Index"
            v-bind:EmployeeID="time.EmployeeID"
            v-bind:StartTime="time.StartTime"
            v-bind:EndTime="time.EndTime"
            v-bind:Date="time.Date"
            v-bind:style="{ 'border-color': HexColor }"
            @click="timeClick" >
              {{ time.StartTime }} - {{ time.EndTime }}
          </button>
        </b-card>
      </b-collapse>
    </div>
</div> 
</template>


<script>
import * as d3 from "d3";

export default {
  name: "TimeViewComponent",
  props: ["EmployeeAv", "RoomAv", "ErrorMessage", "SlotPitch", "Activity", "DayOffset", "SelectedDate", "HexColor"],
  data() {
    return {
      times : [],
      slots : [],
      showError: false,
      tabCount: 1,
      splittedTimes: []
    };
  },
  methods: {
    onLoad: function() {},
    timeClick: function(e)
    {

      var t = this.times[e.target.id];


      var response = {};

      response.RoomID = t.RoomID;
      response.EmployeeID = t.EmployeeID;
      response.Date = t.Date;


      this.$emit('timeClick', response);
    }
  },
  beforeMount() {
    this.onLoad();
  },
  watch: {
    EmployeeAv: function() 
    {
      var time = [];
      var timeslot;
      var collapsedtimeslot;
      var choosenob;
      var test;
      var subtimeslot = [];
      var timeint;
      var offset = this.DayOffset;
      var Estart;
      var Eend;
      var Rstart;
      var Rend;
      var EmployeeIDOfInterval = 0;
      var roundedStart;
      var date;
      var slotpitch = this.SlotPitch;
      var roundto = this.SlotPitch;
      var x = this.EmployeeAv.length;
      var y = this.RoomAv.length;
      var i;
      var j;
      var coeff = 1000 * 60 * parseInt(this.SlotPitch);

      for (i = 0; i < x; i++) 
      {
        date = this.$moment(this.EmployeeAv[i].AvailStart).locale("de");
        roundedStart = this.$moment(Math.ceil(date.valueOf() / coeff) * coeff);

        Estart = this.$moment(roundedStart);
        Eend = this.$moment(this.EmployeeAv[i].AvailEnd).locale("de"); //End mussend be roundet because the Timeslots get splitet into Slots of the Duration lenght
        EmployeeIDOfInterval = this.EmployeeAv[i].EmployeeID;

        for (j = 0; j < y; j++) {
          var dater = this.$moment(this.RoomAv[j].AvailStart).locale("de");
          var roundedStartR = new Date(
            Math.ceil(dater.valueOf() / coeff) * coeff
          );
          
          Rstart = this.$moment(roundedStartR);
          Rend = this.$moment(this.RoomAv[j].AvailEnd).locale("de"); //End mussend be roundet because the Timeslots get splitet into Slots of the Duration lenght if needed can be done with Math.floor()
          
          if (
            Estart.valueOf() < Rstart.valueOf() &&
            Eend.valueOf() < Rstart.valueOf()
          ) {
          } else if (
            Estart.valueOf() >= Rstart.valueOf() &&
            Estart.valueOf() >= Rend.valueOf()
          ) {
          } else if (
            Estart.valueOf() <= Rstart.valueOf() &&
            Eend.valueOf() <= Rend.valueOf()
          ) {
            time.push({
              Starthour: Rstart.format("HH"),
              Startmin: Rstart.format("mm"),
              Endhour: Eend.format("HH"),
              Endmin: Eend.format("mm"),
              EmployeeID: EmployeeIDOfInterval,
              RoomID: this.RoomAv[j].RoomID
            });
          } else if (
            Estart.valueOf() <= Rstart.valueOf() &&
            Eend.valueOf() >= Rend.valueOf()
          ) {
            time.push({
              Starthour: Rstart.format("HH"),
              Startmin: Rstart.format("mm"),
              Endhour: Rend.format("HH"),
              Endmin: Rend.format("mm"),
              EmployeeID: EmployeeIDOfInterval,
              RoomID: this.RoomAv[j].RoomID
            });
          } else if (
            Estart.valueOf() >= Rstart.valueOf() &&
            Eend.valueOf() >= Rend.valueOf()
          ) {
            time.push({
              Starthour: Estart.format("HH"),
              Startmin: Estart.format("mm"),
              Endhour: Rend.format("HH"),
              Endmin: Rend.format("mm"),
              EmployeeID: EmployeeIDOfInterval,
              RoomID: this.RoomAv[j].RoomID
            });
          } else if (
            Estart.valueOf() >= Rstart.valueOf() &&
            Eend.valueOf() <= Rend.valueOf()
          ) {
            time.push({
              Starthour: Estart.format("HH"),
              Startmin: Estart.format("mm"),
              Endhour: Eend.format("HH"),
              Endmin: Eend.format("mm"),
              EmployeeID: EmployeeIDOfInterval,
              RoomID: this.RoomAv[j].RoomID
            });
          }
        }
      }

   
      var slot = [];
      for (i = 0; i < time.length; i++) {

        
        var Start = new Date(this.$moment(this.SelectedDate).year(), this.$moment(this.SelectedDate).month(), this.$moment(this.SelectedDate).day() + 1, time[i].Starthour, time[i].Startmin)
        var End = new Date(this.$moment(this.SelectedDate).year(), this.$moment(this.SelectedDate).month(), this.$moment(this.SelectedDate).day() + 1, time[i].Endhour, time[i].Endmin)
        var slot1 = d3.timeMinute.range(Start, End, slotpitch);

        for (var s = 0; s < slot1.length; s++) {

          var count = d3.timeMinute.count(slot1[s], End);
          
          if (count >= this.Activity.Duration) {

            var dd = this.$moment(this.SelectedDate);
            dd.set({hour: this.$moment(slot1[s]).hour(), minute: this.$moment(slot1[s]).minute()});
            var ddFormat = dd.format("DD-MM-YYYY HH:mm");

            var add = true;

            for(var k = 0; k < slot.length; k++)
            {
              if(slot[k].Date == dd.format("DD-MM-YYYY HH:mm"))
              add = false;
            }
            if(add)
            {
              slot.push({
                Date: ddFormat,
                CompareDate: slot1[s],
                Index: slot.length,
                StartTime: this.$moment(slot1[s]).format("HH:mm"),
                EndTime: this.$moment(this.$moment(slot1[s]).add(this.Activity.Duration, "minutes")).format("HH:mm"),
                EmployeeID: time[i].EmployeeID,
                RoomID: time[i].RoomID
              });
            }
          }


        }
      }


      slot.sort(function (a, b) {
        return a.CompareDate - b.CompareDate;
      });

      this.times = slot.filter((el, i, a) => i === a.indexOf(el));

      if(this.times.length == 0)
        this.showError = true;
      else
        this.showError = false;

      this.tabCount =  parseInt(this.times.length / 6);

      var rest = this.times.length % 6;

      this.splittedTimes = [];

      console.log("TABCOUNT: " + this.tabCount);
      console.log("REST: " + rest);

      for(var i = 0; i < this.tabCount; i++)
      { 
        if(i != this.tabCount - 1)
        {
          console.log("Not last (" + i);
          this.splittedTimes[i] = this.times.slice(i * 6, 6*(i+1));
        }
        else
        {
          console.log("last (" + i);
          this.splittedTimes[i] = this.times.slice(i * 6, parseInt((6*(i+1))+rest));
        }
      } 

      console.log(this.splittedTimes);

    }


  }
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.activity-button {
  margin-left: 3%;
  margin-right: 3%;
  width: 94%;
  padding: 0.75em, 1.25rem;
  color: #000;
  cursor: pointer;
}

.activity-button:hover {
  box-shadow: 0 0 5px #e3e3e3;
}

.time-button
{
  margin-left: 2%;
  margin-right: 2%;
  margin-bottom: 10px;
  max-width: 50%;
  padding: 2%;
  min-width: 40%;
  text-anchor: middle;
  text-align: center;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

#TimeContent {
  padding: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/TimeViewComponent.vue